module.exports = "<div *ngIf=\"showModal\" class=\"modal f c alc\">\n  <div class=\"modal-container\">\n    <div (clickOutside)=\"hideModal()\" [clickOutsideEnabled]=\"outsideClickEnable\" class=\"files f\"  target=\"_blank\" tabindex=\"1\">\n\n      <ng-template [ngTemplateOutlet]=\"modalRef\"></ng-template>\n\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_common/modal/modal.component.html
// module id = ./src/app/_common/modal/modal.component.html
// module chunks = main